export class AdminAbstractPageTemplateComponent {
}